import { CdkDrag, CdkDragEnd, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PopupEntry, PopupManagerService } from 'src/app/services/popup/popup-manager.service';

@Component({
  selector: 'app-popup-wrapper',
  imports: [CdkDrag,CdkDragHandle,CommonModule],
  templateUrl: './popup-wrapper.component.html',
  styleUrl: './popup-wrapper.component.scss',
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupWrapperComponent implements OnInit, AfterViewInit,OnDestroy {
  @Input() entry!: PopupEntry;
  @ViewChild('contentSlot', { read: ViewContainerRef }) contentSlot!: ViewContainerRef
  dragRef!: CdkDrag;


  safeUrl!: SafeResourceUrl;
  private popupManager = inject(PopupManagerService);
  private sanitizer = inject(DomSanitizer);

  constructor() {}

  ngOnInit(): void {
    if(this.entry?.url) {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.entry?.url);
    }
  }

  ngAfterViewInit(): void {
    this.loadComponent();
  }


  private loadComponent(): void {
    if (!this.contentSlot || !this.entry?.component) return;

    this.contentSlot.clear();
    const ref = this.contentSlot.createComponent(this.entry.component);
    
    ref.setInput('popupId',this.entry.id);

    if (this.entry.inputs) {
      Object.entries(this.entry.inputs).forEach(([key, value]) => {
        ref.setInput(key, value);
      });
    }
    setTimeout(()=> {
      ref.changeDetectorRef.detectChanges();
    },0)
  }

  onDragEnd(event: CdkDragEnd): void {
    const freePos = event.source.getFreeDragPosition();

    this.entry.position = {
      x: (this.entry.position?.x ?? 0 ) + freePos.x,
      y: (this.entry.position?.y ?? 0 ) + freePos.y
    };

    event.source.reset();
  }

  onFocus(): void {
    this.popupManager.bringToFront(this.entry.id);
  }

  onFocusOnce(event: MouseEvent): void {
    event.stopPropagation();
    if(this.popupManager.activePopupId === this.entry.id) {
      return;
    }

    this.popupManager.bringToFront(this.entry.id);
  }

  toggleMinimize(): void {
    if(this.entry.minimized) {
      this.popupManager.restore(this.entry.id);
      this.dragRef.reset();
    }else {
      this.popupManager.minimize(this.entry.id);
    }
  }
  minimize(): void {
    this.popupManager.minimize(this.entry.id);
  }

  close(): void {
    this.popupManager.close(this.entry.id);
  }

  ngOnDestroy(): void {
    this.contentSlot?.clear();
  }

  get safeIframeUrl(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.entry?.url ?? '');
  }
}
